import { fetcher } from "helpers/fetcher";

import { TGetStaffIdCardRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getEmployeeIdCard = async (userId: string) => {
  return await fetcher<TGetStaffIdCardRes, any>(
    ENDPOINT.USER.GET_EMPLOYEE_ID_CARD,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.GET_EMPLOYEE_ID_CARD.version,
        [API_HEADER.USER_ID]: userId,
      },
    }
  );
};

export const queryGetEmployeeIdCard = async (userId: string) => {
  return (await getEmployeeIdCard(userId)).data;
};

queryGetEmployeeIdCard._key = (userId: string) => [
  ENDPOINT.USER.GET_EMPLOYEE_ID_CARD.url,
  userId,
];
